const escapeStringRegex = (string) => string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
const mongoRegex = (string, options) => ({ $regex: `.*${escapeStringRegex(string)}.*`, $options: options });
const mongoRegexI = (string) => mongoRegex(string, 'i');

export { mongoRegex, mongoRegexI, escapeStringRegex };
